<div class="public-layout">
  <app-public-header></app-public-header>
  <main class="main" id="main-content">
    <router-outlet></router-outlet>
    <div class="flex-grow-1"></div>
    <app-public-footer></app-public-footer>
  </main>
  <app-launch-modal></app-launch-modal>
</div>